import { Controller } from "@hotwired/stimulus";

// Payment "reason" toggle on the request/pay forms. When the selected reason is
// an expense, the expense-only fields (category, date, receipt) are shown and
// the receipt is required; for a "work" fee or a "bonus" they're hidden and the
// receipt's `required` is dropped so the form can submit without one. Progressive
// enhancement — the server enforces the same rule, so the form is correct even
// if this never runs.
export default class extends Controller {
  static targets = ["expenseField", "receiptInput"];

  connect() {
    this.update();
  }

  change() {
    this.update();
  }

  update() {
    const expense = this.selectedReason() === "expense";

    this.expenseFieldTargets.forEach((field) => {
      field.classList.toggle("is-hidden", !expense);
    });

    this.receiptInputTargets.forEach((input) => {
      input.required = expense;
      if (!expense) input.value = "";
    });
  }

  selectedReason() {
    const checked = this.element.querySelector('input[name="reason"]:checked');
    return checked ? checked.value : null;
  }
}
